// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton_container__Pu6xx","main":"Skeleton_main__2A792","flashCard":"Skeleton_flashCard__QhXos","first":"Skeleton_first__m_3FN","second":"Skeleton_second__UakWt"};